module.exports = __webpack_public_path__ + "assets/img/chatbotTrain.4932da90.png";